export default __webpack_public_path__ + "static/anton-687c0bcd934267227abbbce4b1038c08.webp";